import React from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { GridActionsCellItem, type GridColDef } from '@mui/x-data-grid-premium';

import { Icon, showDeleteDialog, TabFab, useSettings, Utils } from 'app/main/components';
import { ViewTable, ViewTableUtils } from 'app/main/components/page-layouts';

import { showOrdersStandardNotesEditDialog } from '../../components/OrdersStandardNotesEditDialog';

export default function OrdersStandardNotesTab() {
	const dispatch = useDispatch();
	const { t } = useSettings();

	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(value => !value);

	function addNewStandardNote() {
		dispatch(showOrdersStandardNotesEditDialog({ baseModel: {}, isAdd: true, updateRefresh }));
	}

	function editStandardNote(row) {
		dispatch(showOrdersStandardNotesEditDialog({ baseModel: row, updateRefresh }));
	}

	function deleteStandardNote(row) {
		dispatch(
			showDeleteDialog({
				module: 'orders_standardnotes',
				id: row.osnt_uid,
				hardDelete: true,
				replace: false,
				updateRefresh
			})
		);
	}

	const columns: GridColDef[] = [
		{
			field: 'osnt_title',
			headerName: t('DETAILS_ORDERS_STANDARDNOTES_FIELD_TITLE'),
			minWidth: 200,
			flex: 1,
			renderCell: ViewTableUtils.renderCellWithTooltip
		},
		{
			field: 'actions',
			type: 'actions',
			headerName: t('VIEW_TABLE_COLUMN_ACTIONS'),
			width: 100,
			cellClassName: 'actions',
			getActions: ({ row }) => [
				<GridActionsCellItem
					icon={<Icon icon="edit" />}
					label={t('VIEW_ITEM_BUTTON_EDIT')}
					onClick={() => editStandardNote(row)}
				/>,
				<GridActionsCellItem
					icon={<Icon icon="delete" />}
					label={t('VIEW_ITEM_BUTTON_DELETE')}
					onClick={() => deleteStandardNote(row)}
				/>
			]
		}
	];

	return (
		<Box className="w-full">
			<ViewTable
				module="orders_standardnotes"
				columns={columns}
				refresh={refresh}
				updateRefresh={updateRefresh}
			/>
			<TabFab label={t('ORDERS_STANDARDNOTES_ADD')} icon="add-circle" onClick={addNewStandardNote} />
		</Box>
	);
}
